// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"_1bj80___Checkmark-module__checkmark","show":"_3MeCW___Checkmark-module__show"};